import * as React from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
import { func } from "../../../../utils";
import Show from "../../../atoms/Show/Show";
import { Wrapper } from "../TrainingCampSoc/TrainingCampSoc.styled";

import { ReactComponent as ChampionText } from "./assets/champions-text.svg";
import { ReactComponent as ChampionTextDesktop } from "./assets/champions-text-desktop.svg";
import Tabs from "../../../atoms/Tabs/Tabs";
import CardChampionSoc from "../../../atoms/CardChampionSoc";
import SliderWrapper from "../../../atoms/SliderWrapper";
import useDebounce from "../../../../hooks/useDebounce";
import { SliderContainer } from "./ChampionsSliderSoc.styled";
import { useFetchMainRegionSOc, useFetchSocChampions } from "../../../../networks";
import { Description, EmptyStateWrapper } from "../TimelineSection/TimelineSection.styled";
// @ts-ignore
import { ReactComponent as EmptyState } from "../../../molecules/v2/TimelineSection/assets/empty-state.svg";
// @ts-ignore
import { ReactComponent as EmptyStateDesktop } from "../../../molecules/v2/TimelineSection/assets/empty-state-desktop.svg";
import { useLocation } from "react-router-dom";

const ChampionsSliderSoc: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const year = searchParams.get("year");
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const [slug, setSlug] = React.useState("");
  const [isChangeTab, setIsChangeTab] = React.useState(false);

  const currentYear = new Date()?.getFullYear();

  const { data: dataMainRegionSocRaw, isFetching } = useFetchMainRegionSOc();

  const dataEventSeries =
    dataMainRegionSocRaw?.data?.data?.eventSeries?.filter((val) => val?.slug !== "soc") ?? [];

  const dataEventSeriesActiveTab = React.useMemo(() => {
    const data = [...dataEventSeries]?.map((data) => {
      return {
        ...data,
        title: data?.main_region_name,
      };
    });

    return data;
  }, [dataEventSeries]);

  const dataFirstRegionSlug = dataEventSeriesActiveTab?.[0]?.slug;
  const isShouldFetchChampion = !!dataFirstRegionSlug || !!slug;

  const { data: dataChampionsSocRaw, isFetching: fetchingChampionsSoc } = useFetchSocChampions(
    {
      region: slug || dataFirstRegionSlug,
      year: year === "2024" ? "2024" : currentYear,
    },
    isShouldFetchChampion,
  );

  const dataChampionSoc = dataChampionsSocRaw?.data?.data?.champions ?? [];

  const getBackgroundImage = React.useCallback(() => {
    if (isMobileView) return func.getStaticImg("illustration/champion-slider-bg-m.png");

    return func.getStaticImg("illustration/champions-bg.png");
  }, [isMobileView]);

  const backgroundImage = getBackgroundImage();

  const handleChangeTab = (data) => {
    setIsChangeTab(true);
    setSlug(data?.slug);
  };

  const handleOnClick = (data) => {
    setIsChangeTab(false);
    setSlug(data?.slug);
  };

  useDebounce(
    () => {
      if (slug && isChangeTab) {
        setIsChangeTab(false);
      }
    },
    600,
    [slug],
  );

  if (isFetching) return null;

  return (
    <div className="relative">
      {/* @ts-ignore */}
      <Wrapper id="timeline-soc" backgroundImage={backgroundImage}>
        <Show when={isMobileView}>
          {/* <div className="my-auto relative top-[-80px] pb-[20px] px-[16px]"> */}
          {/* to make it centered */}
          <div className="my-auto pl-[16px]">
            <div className="flex flex-col gap-y-[12px]">
              <ChampionText />
              <h3 className="uppercase text-white text-[16px] font-[500]">
                From {currentYear === 2025 ? 27 : 19} citIES across the nation
              </h3>
            </div>
            <div className="mt-[30px]">
              <Tabs
                className="!gap-x-2"
                onChange={handleChangeTab}
                onClick={handleOnClick}
                tabsType="chips"
                // @ts-ignore
                tabList={dataEventSeriesActiveTab}
              />

              <Show when={!fetchingChampionsSoc && dataChampionSoc?.length > 0}>
                <div className="my-[30px] flex overflow-auto w-[100%] gap-x-[16px] pr-[16px]">
                  <React.Fragment>
                    {/* empty state next dev */}

                    {dataChampionSoc?.map((data: any, idx: number) => (
                      <CardChampionSoc
                        key={idx}
                        cardWidth="252px"
                        city={data?.region_name}
                        kvUrl={data?.key_visual_champion_mobile}
                        schoolLogoUrl={data?.school_logo}
                        schoolName={data?.school_name}
                      />
                    ))}
                  </React.Fragment>
                </div>
              </Show>
              <Show when={dataChampionSoc?.length <= 0 && !fetchingChampionsSoc}>
                <EmptyStateWrapper style={{ marginTop: 30 }}>
                  {isMobileView ? <EmptyState /> : <EmptyStateDesktop />}
                </EmptyStateWrapper>
              </Show>
            </div>
          </div>
        </Show>

        <Show when={!isMobileView}>
          <div className="m-auto relative top-[-180px] w-[1136px] flex flex-col items-center">
            <div className="flex flex-col items-center gap-y-[12px]">
              <ChampionTextDesktop />
              <h3 className="uppercase text-white text-[24px] font-[500]">
                From {currentYear === 2025 ? 27 : 19} Cities across the nation
              </h3>
            </div>

            <div className="mt-[30px]">
              <Tabs
                onChange={handleChangeTab}
                onClick={handleOnClick}
                tabsType="chips"
                position="center"
                // @ts-ignore
                tabList={dataEventSeriesActiveTab}
              />

              <SliderContainer>
                {/* empty state next dev */}
                <Show when={dataChampionSoc?.length > 0 && !fetchingChampionsSoc}>
                  {/* @ts-ignore */}
                  <SliderWrapper
                    showDotsIndicator={true}
                    showItems={dataChampionSoc?.length >= 4 ? 4 : 0}
                    showArrow={dataChampionSoc?.length > 4}
                    step={1}
                    style={{
                      width: "1162px",
                    }}
                    cardWrapperStyle={{ width: "100%" }}
                    totalData={dataChampionSoc?.length ?? 0}
                    swipeable={false}
                    isCenter={true}
                  >
                    {({ cardWidth }) => {
                      return (
                        <>
                          {dataChampionSoc?.map((data, idx) => (
                            <CardChampionSoc
                              key={idx}
                              cardWidth="252px"
                              city={data?.region_name}
                              kvUrl={data?.key_visual_champion}
                              schoolLogoUrl={data?.school_logo}
                              schoolName={data?.school_name}
                            />
                          ))}
                        </>
                      );
                    }}
                  </SliderWrapper>
                </Show>
                <Show when={dataChampionSoc?.length <= 0 && !fetchingChampionsSoc}>
                  <EmptyStateWrapper>
                    {isMobileView ? <EmptyState /> : <EmptyStateDesktop />}
                  </EmptyStateWrapper>
                  {/* <Description style={{ textAlign: "center" }}>
                    Segera!!! Akan hadir di Kotamu Piala by.U {currentYear},
                    jangan sampai kelewatan!
                  </Description> */}
                </Show>
              </SliderContainer>
            </div>
          </div>
        </Show>
      </Wrapper>
    </div>
  );
};

export default ChampionsSliderSoc;
